import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import VoiceBotComponent from '@vz-react/ces-voice-assistant-client';
import { getCookie } from '../../common/Helpers';
import { useVoiceBotContext } from './contexts/VoiceBotContext';
import { useFwaVoiceBotSocketCallback } from './hooks/useFwaVoiceBotSocketCallback';
import { getVoiceBotPageName, syncVoiceBotPageContextToShell } from './voiceBotPageNames';

const VoiceBotEnabled = ({ routePageName }) => {
  const { isFooterSticky, errorMessage } = useVoiceBotContext();

  const [domainName] = useState(
    /* istanbul ignore next */
    () => (typeof window !== 'undefined' ? window.location?.hostname : 'localhost')
  );
  const [pageName, setPageName] = useState(() => getVoiceBotPageName());
  const [flowName, setFlowName] = useState('');

  const { cesWebSocketCallback, textMessage } = useFwaVoiceBotSocketCallback(pageName);

  useEffect(() => {
    const { page, flow } = syncVoiceBotPageContextToShell();
    setPageName(page);
    setFlowName(flow || '');
  }, [routePageName]);

  if (!domainName) {
    return null;
  }
  return (
    <VoiceBotComponent
      agentName="homebot"
      agentType="sales"
      domainName={domainName}
      pageName={pageName || 'progressive plans'}
      flowName={flowName || 'NSE'}
      hideButton={false}
      newVoiceBotUIFFlag
      intentType="NSE"
      enableCrossPagePersistence
      bottomOffset={isFooterSticky ? '107px' : '0px'}
      bottomOffsetMobile={isFooterSticky ? '96px' : '0px'}
      socketCallback={cesWebSocketCallback}
      toolMessage={errorMessage}
      textMessage={textMessage}
    />
  );
};

VoiceBotEnabled.propTypes = {
  routePageName: PropTypes.string,
};

const VoiceBot = ({ pageName: routePageName }) => {
  const voiceBotEnabledByCookie =
    getCookie('cesVoiceBot') === 'true' ||
    getCookie('newVoiceBot') === 'true';

  if (!voiceBotEnabledByCookie) {
    return null;
  }

  return <VoiceBotEnabled routePageName={routePageName} />;
};

VoiceBot.propTypes = {
  pageName: PropTypes.string,
};

export default VoiceBot;
